var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarOutlinecomponent = function SvgStarOutlinecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.107 6.465 5.393.465-4.088 3.547 1.223 5.273L9 12.953 4.365 15.75l1.23-5.273L1.5 6.93l5.393-.457L9 1.5l2.107 4.965ZM6.18 13.252 9 11.55l2.828 1.71-.75-3.21 2.49-2.16-3.285-.285L9 4.575 7.725 7.597l-3.285.285 2.49 2.16-.75 3.21Z",
    fill: "current"
  })));
};
export default SvgStarOutlinecomponent;